import { render, staticRenderFns } from "./MyPlan.vue?vue&type=template&id=5d757fd0&"
import script from "./MyPlan.vue?vue&type=script&lang=js&"
export * from "./MyPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports